export default {
  data:()=>({
    mounted: false,
    mountedDelay: false,
    mountedDelayTimer: null,
  }),
  mounted() {
    this.mounted = true;
    this.mountedDelayTimer = setTimeout(()=>{
      this.mountedDelay = true;
    }, 50);
  },
  destroyed() {
    this.mounted = false;
    if(this.mountedDelayTimer!==null)
      clearTimeout(this.mountedDelayTimer);
    this.mountedDelay = false;
  }
}